<template>
  <div class="d-flex justify-end text-right">
    <div :class="`selectedTransfers d-flex pa-3 white rounded ${ hasSelectedTransfers ? 'show' : ''}`">
      <v-btn @click="bulkTransfer" color="primary" elevation="0">
        <v-icon left>mdi-cash-fast</v-icon>
        <span class="body-2">
          {{ $t('transfer.label.transferToSelected') }}
        </span>
      </v-btn>
    </div>
    <v-btn @click="fetchTransferReport" :disabled="isGeneratingReport" color="primary" elevation="0">
      <v-progress-circular v-if="isGeneratingReport" :size="14" :width="2" color="grey" class="mr-2" indeterminate />
      <v-icon v-else left>mdi-download-box-outline</v-icon>
      <span class="d-none d-md-flex body-2">
        {{ $t('transfer.label.generateReport') }}
      </span>
    </v-btn>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'

export default {
  name: 'TransferHeaderActions',

  computed: {
    ...mapGetters(['isGeneratingReport']),

    hasSelectedTransfers() {
      return this.selectedTransfers.length > 0
    },
  },

  methods: {
    ...mapActions(['fetchTransferReport']),
    ...mapMutations(['openModal']),

    bulkTransfer() {
      this.parsedTransfers = []
      this.selectedTransfers.map((transfer) => this.parsedTransfers.push(transfer.id))
      this.$nextTick(() => this.openModal('TRANSFER_CONFIRM_MODAL'))
    },
  },

  data() {
    return {
      selectedTransfers: [],
    }
  },

  mounted() {
    this.$watch('$parent.$parent.$refs.financialRouterView.selectedTransfers', (selectedTransfers) => {
      this.selectedTransfers = selectedTransfers
    })
  }
}
</script>

<style>
.selectedTransfers {
  position: fixed;
  height: 60px;
  right: 165px;
  top: 13px;
  opacity: 0;
  z-index: -1;
  transform: scale(0.9);
  transition: 700ms all cubic-bezier(.75,-0.5,0,1.75);
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.05);
}

.selectedTransfers.show {
  opacity: 1;
  z-index: 2;
  transform: scale(1);
}
</style>
